export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13568.3ac77886.jpg";